export default __webpack_public_path__ + "static/image/company.e642c7db.jpg";